import { render, staticRenderFns } from "./GenerateNew.vue?vue&type=template&id=5e4f0f61&scoped=true"
import script from "./GenerateNew.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateNew.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GenerateNew.vue?vue&type=style&index=0&id=5e4f0f61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f0f61",
  null
  
)

export default component.exports